import type { SupportedLanguage } from "@amtana/i18n";

// ADR-034 points 1 and 7: a page family's link list. The footer reads it, a page's body may read
// it, and a family with no pages yet shows no column.

type InEachLanguage = Readonly<Record<SupportedLanguage, string>>;

export type FamilyLinks = {
  /** The family's footer column. */
  readonly title: InEachLanguage;
  /** Each page of the family, by its English address; the footer moves it under "/es/". */
  readonly links: ReadonlyArray<{ readonly label: InEachLanguage; readonly href: `/${string}` }>;
};

/** One footer column per family with a page, in `language`. */
export function familyFooterColumns(families: readonly FamilyLinks[], language: SupportedLanguage) {
  return families
    .filter((family) => family.links.length > 0)
    .map((family) => ({
      title: family.title[language],
      links: family.links.map((link) => ({ label: link.label[language], href: link.href as string })),
    }));
}
